<div class="report-container" onwheel="">
  <div id="dashboard-report"></div>
  <acquisition-chart [containers]="acquisitionContainers"></acquisition-chart>
</div>
